module.exports = __webpack_public_path__ + "static/media/check.2cd27446.svg";